"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chapter = void 0;
var chapter_card_1 = require("../../components/entities/chapter-card");
var chapter_cell_1 = require("../../components/entities/chapter-cell");
var chapter_details_banner_1 = require("../../components/entities/chapter-details-banner");
var create_entity_1 = require("../../utils/create-entity");
var chapter_details_layout_1 = require("../../components/entities/chapter-details-layout");
var graphql_1 = require("../../utils/graphql");
exports.Chapter = {
  name: 'Chapter',
  autoRoutes: ['list', 'create', 'details', 'update'],
  groupName: 'Community',
  useConnections: true,
  useModerators: true,
  useConversation: true,
  usePublishStatus: true,
  useSlices: true,
  includeInSearch: true,
  // useNetwork: true,
  canEmbed: true,
  components: {
    details: chapter_details_layout_1.ChapterDetailsLayout,
    cell: chapter_cell_1.ChapterCell,
    card: chapter_card_1.ChapterCard,
    banner: chapter_details_banner_1.ChapterDetailsBanner
  },
  banner: {
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      parent { id slug name openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url } }}\n    "], ["\n      parent { id slug name openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url } }}\n    "])))
  },
  table: {
    fieldNames: ["name", "locations", "director", "createdBy"]
  },
  form: {
    modal: {
      maxWidth: '800px'
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'roles'
    }, {
      name: 'places'
    }, {
      name: 'taxonomies',
      label: process.env.TAXONOMIES_LABEL || 'Challenges & Goals'
    }, {
      name: 'activity'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      banner: {
        type: 'banner',
        fieldSet: 'overview'
      },
      description: {
        type: 'description'
      },
      parent: {
        type: 'parent'
      },
      files: {
        type: 'linkedMultiple',
        entityTypeName: 'FileAsset'
      },
      roles: {
        type: 'linkedTable',
        label: "{{PEOPLE}}",
        isVisible: function (context) {
          return !context.isModal;
        },
        entityTypeName: 'ChapterRole',
        fieldSet: 'roles',
        description: 'Define the key People involved in this chapter, and their roles.'
      },
      organisationRoles: {
        type: 'linkedTable',
        label: "{{ORGANISATIONS}}",
        isVisible: function (context) {
          return !context.isModal;
        },
        entityTypeName: 'OrganisationChapterRole',
        fieldSet: 'roles',
        description: 'Define the Organisations who are involved in this Chapter, and their roles.'
      },
      teams: {
        type: 'linkedMultiple',
        entityTypeName: 'Team',
        fieldSet: 'roles'
      },
      locations: {
        type: 'linkedMultiple',
        entityTypeName: 'Location',
        fieldSet: 'places'
      },
      countries: {
        type: 'linkedMultiple',
        entityTypeName: 'Economy',
        fieldSet: 'places'
      },
      sdgs: {
        type: 'linkedMultiple',
        entityTypeName: 'Sdg',
        fieldSet: 'taxonomies'
      },
      feedEntries: {
        type: 'linkedMultiple',
        entityTypeName: 'FeedEntry',
        fieldSet: 'library'
      },
      links: {
        type: 'linkedMultiple',
        entityTypeName: 'Link',
        fieldSet: 'library'
      },
      videos: {
        type: 'linkedMultiple',
        entityTypeName: 'Video',
        fieldSet: 'library'
      },
      challenges: {
        type: 'linkedMultiple',
        entityTypeName: 'Challenge',
        fieldSet: 'taxonomies'
      },
      keyIssues: {
        type: 'linkedMultiple',
        entityTypeName: 'KeyIssue',
        fieldSet: 'taxonomies'
      },
      trends: {
        type: 'linkedMultiple',
        entityTypeName: 'Trend',
        fieldSet: 'taxonomies'
      },
      topics: {
        type: 'linkedMultiple',
        entityTypeName: 'Topic',
        fieldSet: 'taxonomies'
      },
      subTopics: {
        type: 'linkedMultiple',
        entityTypeName: 'SubTopic',
        fieldSet: 'taxonomies'
      },
      events: {
        type: 'linkedMultiple',
        entityTypeName: 'Event',
        fieldSet: 'activity'
      },
      documents: {
        type: 'linkedMultiple',
        entityTypeName: 'Document',
        fieldSet: 'activity'
      },
      impactResults: {
        type: 'linkedTable',
        entityTypeName: 'ImpactResult',
        fieldSet: 'activity'
      },
      impactStories: {
        type: 'linkedMultiple',
        entityTypeName: 'ImpactStory',
        fieldSet: 'activity'
      },
      workstreams: {
        type: 'linkedMultiple',
        entityTypeName: 'Workstream',
        fieldSet: 'activity'
      }
    })
  },
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      description { id text }\n      banner { id name slug title description { text } alternateText openGraph { id image { id url } } }\n      roles {\n        ...EntityValueFields\n        role { ...EntityValueFields }\n        person { ...EntityValueFields }\n      }\n      directors { ...EntityValueFields }\n      children { ...EntityValueFields }\n      workstreams { ...EntityValueFields }\n      teams { id }\n      files { ...FileAssetValueFields }\n      organisationRoles { \n        id\n        slug\n        role { id name slug }\n        organisation { ...EntityValueFields }\n      }\n      challenges { ...EntityValueFields }\n      keyIssues { ...EntityValueFields }\n      trends { ...EntityValueFields }\n      topics { ...EntityValueFields }\n      subTopics { ...EntityValueFields }\n\n      locations { ...EntityValueFields }\n      impactStories { ...EntityValueFields }\n      countries { ...EntityValueFields }\n      documents { ...EntityValueFields }\n      sdgs { ...EntityValueFields number }\n      feedEntries { ...EntityValueFields }\n      people { ...EntityValueFields }\n      organisations { id }\n    "], ["\n      description { id text }\n      banner { id name slug title description { text } alternateText openGraph { id image { id url } } }\n      roles {\n        ...EntityValueFields\n        role { ...EntityValueFields }\n        person { ...EntityValueFields }\n      }\n      directors { ...EntityValueFields }\n      children { ...EntityValueFields }\n      workstreams { ...EntityValueFields }\n      teams { id }\n      files { ...FileAssetValueFields }\n      organisationRoles { \n        id\n        slug\n        role { id name slug }\n        organisation { ...EntityValueFields }\n      }\n      challenges { ...EntityValueFields }\n      keyIssues { ...EntityValueFields }\n      trends { ...EntityValueFields }\n      topics { ...EntityValueFields }\n      subTopics { ...EntityValueFields }\n\n      locations { ...EntityValueFields }\n      impactStories { ...EntityValueFields }\n      countries { ...EntityValueFields }\n      documents { ...EntityValueFields }\n      sdgs { ...EntityValueFields number }\n      feedEntries { ...EntityValueFields }\n      people { ...EntityValueFields }\n      organisations { id }\n    "])))
  },
  list: {
    hasSearch: true,
    banner: {
      content: 'Manage Chapter groups across the world.'
    },
    queryFields: (0, graphql_1.graphql)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      description { id plain(truncate: { words: 80 }) }\n      openGraph {\n        id\n        image {\n          id\n          url\n        }\n      }\n      people { id }\n      challenges { id }\n      sdgs { id }\n      organisations { id }\n      workstreams { id }\n      organisationRoles { \n        id\n        slug\n        role { id name slug }\n        organisation { id name slug url logo { id url thumbnails { id full { id url width height } } } }\n      }\n      roles {\n        id\n        role { id name slug }\n        person {\n          id\n          slug\n          name\n          photo {\n            id url thumbnails { id full { id url width height } }\n          }\n          location {\n            id\n            name\n            slug\n          }\n        }\n      }\n    "], ["\n      description { id plain(truncate: { words: 80 }) }\n      openGraph {\n        id\n        image {\n          id\n          url\n        }\n      }\n      people { id }\n      challenges { id }\n      sdgs { id }\n      organisations { id }\n      workstreams { id }\n      organisationRoles { \n        id\n        slug\n        role { id name slug }\n        organisation { id name slug url logo { id url thumbnails { id full { id url width height } } } }\n      }\n      roles {\n        id\n        role { id name slug }\n        person {\n          id\n          slug\n          name\n          photo {\n            id url thumbnails { id full { id url width height } }\n          }\n          location {\n            id\n            name\n            slug\n          }\n        }\n      }\n    "])))
  }
};
var templateObject_1, templateObject_2, templateObject_3;